/**
 * Compute RevoGrid height in pixels so all rows fit without internal scroll.
 * Defaults sized for "material" theme (header ~50px, row ~42px).
 */
export interface RevoGridHeightOptions {
  /** Height of header area in px. Default: 50 */
  headerHeight?: number;
  /** Height per row in px. Default: 42 */
  rowHeight?: number;
  /** Whether to include header height. Default: true */
  includeHeader?: boolean;
  /** Minimum height in px to enforce. Optional. */
  min?: number;
  /** Extra pixels to add (e.g., for footers). Optional. */
  extra?: number;
}

export function computeRevoGridHeight(
  rowCount: number,
  options: RevoGridHeightOptions = {},
): number {
  const {
    headerHeight = 50,
    rowHeight = 42,
    includeHeader = true,
    min,
    extra = 0,
  } = options;

  const header = includeHeader ? headerHeight : 0;
  let height = header + Math.max(0, rowCount) * rowHeight + extra;
  const heightWithBuffer = height * 1.08;
  if (typeof min === 'number') height = Math.max(height, min);
  return heightWithBuffer;
}

